"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _NotificationConfigurationDeprecated_1 = require("./_NotificationConfigurationDeprecated");
exports.PutBucketNotificationInput = {
    type: "structure",
    required: ["Bucket", "NotificationConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        NotificationConfiguration: {
            shape: _NotificationConfigurationDeprecated_1._NotificationConfigurationDeprecated,
            locationName: "NotificationConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "NotificationConfiguration"
};
//# sourceMappingURL=PutBucketNotificationInput.js.map